import React, { Component } from 'react';
import { Row, Input, DatePicker, message, Button, Spin } from "antd";
import moment from 'moment';
import imgSave from "../../saveImg";
import Auth from "../../Auth";
const { TextArea } = Input;
const { MonthPicker } = DatePicker;

class index extends Component {
    constructor(props) {
        super(props);
        this.state = {
            date: moment().subtract(1, 'month').format('YYYY-MM'),
            note: {
                note: ""
            },
            loading: true,
            loadingSave: false,
            print: false
        }
    }

    componentDidMount() {
        this.getNote(this.state.date);
    }

    getNote = (date) => {
        fetch(`/_5_1_5_info?year=${moment(date).format('YYYY')}&month=${moment(date).format('M')}`, { credentials: 'include' }).then(x => x.json()).then(x => {
            let note = {}
            if (x.data && x.data.length > 0) {
                note = { ...x.data[0] }
            }
            this.setState({ loading: false, note });
        }).catch(err => {
            this.setState({ loading: false });
            console.error(err);
        })
    }


    onSaveNote = () => {
        this.setState({ loadingSave: true });
        let date = this.state.date;
        if (!date) {
            message.error('请选择年份月份');
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            return
        }
        let year = moment(date).format("YYYY");
        let month = moment(date).format("M");
        let data = [{ ...this.state.note, year, month }]
        let dataFrom = new FormData();
        dataFrom.append('data', JSON.stringify(data));
        let headres = {
            method: 'post',
            credentials: 'include',
            headers: {},
            body: dataFrom
        }
        fetch('/add_5_1_5', headres).then(x => x.json()).then(x => {
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            if (x.status == 1) {
                message.success(x.msg);
                if (!data[0].id) {
                    this.getNote(this.state.date);
                }
                return
            }
            message.error('备注保存失败：' + x.msg);
        }).catch(err => {
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            console.error(err);
            message.error('保存失败' + JSON.stringify(err));
        })
    }

    downloadSG = () => {

        this.setState({ print: true, loading: true }, () => {
            imgSave('table5_1_5', 1.5, '5.15', this.state.date).then(x => {
                if (x.status == 1) {
                    message.info('添加成功！');
                } else {
                    message.error('添加失败' + x.msg);
                }

                this.setState({
                    print: false,
                    loading: false
                });
            }).catch(err => {
                console.error(err);
                this.setState({
                    print: false,
                    loading: false
                });
            })

        });

    }

    render() {
        return (
            <div className="table7_1_1">
                <Spin spinning={this.state.loading}>
                    <Row className="title" id="table5_1_5" >
                        <Row style={{ margin: "20px 0", }}>
                            <Row style={{ margin: "10px 0" }}>5.1.5  Please critique if variance above +/- 5% 若差异数超过上下百分之五则需做出书面解释</Row>
                            <Row className="table-month">
                                <MonthPicker
                                    placeholder="请选择年月"
                                    monthCellContentRender={(date, local) => {
                                        return moment(date).format('M月')
                                    }}
                                    defaultValue={moment(this.state.date, "YYYY-MM")}
                                    format="YYYY-MM"
                                    onChange={(date, str) => {
                                        this.setState({
                                            date: str,
                                            loading: true,
                                            note: {}
                                        });
                                        this.getNote(str)
                                    }}
                                />
                            </Row>
                            <TextArea
                                autosize={{ minRows: 4 }}
                                style={{ marginTop: 20 }}
                                placeholder="请输入备注！"
                                value={this.state.note.note}
                                onChange={(e) => {
                                    this.setState({
                                        note: { ...this.state.note, note: e.target.value }
                                    });
                                }}
                            />
                        </Row>
                    </Row>
                    <Auth loading={this.state.loading} auth="edit_5_1">
                        <Row className="table-footer-btn">
                            <Button
                                type="primary"
                                style={{ marginRight: 10 }}
                                onClick={this.downloadSG}
                                loading={this.state.print}
                            >加入pdf</Button>
                            <Button
                                type="primary"
                                onClick={this.onSaveNote}
                                loading={this.state.loadingSave}
                            >保存</Button>
                        </Row>
                    </Auth>

                </Spin>
            </div>
        );
    }
}

export default index;


// WEBPACK FOOTER //
// ./src/components/table/5.0/5-1/5-1-5.js